import styled from 'styled-components'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { DropDownList } from '@progress/kendo-react-dropdowns'

import { Colors } from '../../../styles'

const Container = styled.div`
  margin: 33px;
`

const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height}px;
`

const Header = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
`

const HeaderWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
  justify-content: space-between;
`

const StyledDropDown = styled(DropDownList)`
  border-radius: 4px;
  height: 33px;
  background-color: white !important;
  span.k-dropdown-wrap.k-state-default {
    border-color: #dce6f9;
    background-image: none;
    background-color: transparent;
  }
`

const StyledDatePicker = styled(DatePicker)`
  border-radius: 4px;
  border: 1.5px solid #dce6f9;
  background: white;
  span.k-picker-wrap.k-state-default.k-picker-wrap {
    padding: 0px;
  }
`

const FilterWrapper = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`

const ButtonExport = styled.button`
  gap: 8px;
  color: ${({ disabled }) => disabled ? Colors.cancelTextColor : Colors.deepBlue};
  border: 1px solid ${({ disabled }) => disabled ? Colors.cancelTextColor : Colors.deepBlue};
  height: 33px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  padding: 8px 16px;
  min-width: 150px;
  align-items: center;
  border-radius: 4px;
  background-color: ${({ disabled }) => disabled ? Colors.modalGrey : Colors.white};
`

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${Colors.cancelTextColor};
`

// table styles
const TableContainer = styled.div`
  width: 100%;
  height: ${({ height }) => `${height}px` || '70vh'};
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
`

const Table = styled.table`
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
`

const Thead = styled.thead`
  background-color: #0d658c;
  color: white;
`

const Tbody = styled.tbody`
  font-size: 14px;
`

const Tr = styled.tr`
  height: ${({ height }) => height || '40px'};
  background-color: ${({ index }) => (index % 2 === 0 ? '#f8f8f8' : '#ffffff')};
`

const Th = styled.th`
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
  font-weight: bold;
  background-color: ${({ backgroundColor }) => backgroundColor || Colors.deepBlue};
  color: ${Colors.white};
`

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  font-weight: ${({ fontWeight }) => fontWeight || '500'};
  text-align: center;
`

const SubTotalRow = styled.tr`
  background-color: #b0b0b0;
  font-weight: bold;
  color: white;
`

const EmptyRecordContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Colors.borderGrey};
  border-radius: 8px;
  height: ${(props) => props.height}px;
`

const EmptyRecordText = styled.p`
  color: ${Colors.cancelTextColor};
  margin: 0;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
`

export default {
  Tr,
  Th,
  Td,
  Table,
  Thead,
  Tbody,
  Label,
  Header,
  Container,
  SubTotalRow,
  ButtonExport,
  HeaderWrapper,
  FilterWrapper,
  StyledDropDown,
  TableContainer,
  EmptyRecordText,
  LoadingContainer,
  StyledDatePicker,
  EmptyRecordContainer,
}